module.exports = require("./de-LU.d.ts");